<div class="page-breadcrumb" *ngIf="write==true || read==true || delete==true ">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">SMS Notification Text Management</h4>
        </div>

    </div>
</div>

<div style="display: block;Width:13%;margin-left: 30px;" *ngIf="write==true">
    <div class="mt-3" >
        <a *ngIf="!show" href="javascript:void(0)" (click)="addAppNotificationText()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Add </span>
        </a>
        <a *ngIf="show" href="javascript:void(0)" (click)="addAppNotificationText()"
            class="btn create-btn text-white no-wrap d-flex align-items-center">
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
            <span class="hide-menu ml-2 text-uppercase">Remove </span>
        </a>
    </div>
</div>
<!-- ============================================================== -->


<div *ngIf="show">
    <div style="margin-top: -19px;">

        <div class="container-fluid">
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <div class="row">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <form #smsNotificationText="ngForm" novalidate>
                                <div class="form-body">
                                    <h5 class="card-title"> SMS Notification Text Management</h5>
                                    <hr>
                                    <div class="row">

                                        <!--/span-->
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> <span class="text-danger">*</span>
                                                    Notification Type</label>
                                                <select class="form-control" id="notificationType" required
                                                    #notificationType="ngModel" onfocus='this.size=5;'
                                                    onblur='this.size=1;' onchange='this.size=1; this.blur();'
                                                    name="notificationType"
                                                    [(ngModel)]="smsNotificationTextAddObj.notificationType"
                                                    data-placeholder="Choose a Notification Type" tabindex="1">
                                                    <option value="User Sign Up Successful/Failure ">User Sign Up
                                                        Successful/Failure </option>
                                                    <option value="Account Sign UP ">Account Sign UP </option>
                                                    <option value="Primary User Approval ">Primary User Approval
                                                    </option>
                                                    <option value="Add Items to Current Inventory ">Add Items to Current
                                                        Inventory </option>
                                                    <option value="Edit Items from Current Inventory  ">Edit Items from
                                                        Current Inventory </option>
                                                    <option value="Update Items in Current Inventory  ">Update Items in
                                                        Current Inventory </option>
                                                    <option value="Add Items to Shopping Cart  ">Add Items to Shopping
                                                        Cart </option>
                                                    <option value="Edit Items from Shopping Cart  ">Edit Items from
                                                        Shopping Cart </option>
                                                    <option value="Update Items in Shopping Cart  ">Update Items in
                                                        Shopping Cart </option>
                                                    <option value="Add Items to Open Order  ">Add Items to Open Order
                                                    </option>
                                                    <option value="Edit Items from Open Order  ">Edit Items from Open
                                                        Order </option>
                                                    <option value="Update Items from Open Order  ">Update Items from
                                                        Open Order </option>
                                                    <option value="Add Items to Order History">Add Items to Order
                                                        History</option>
                                                    <option value="Edit Items from Order History">Edit Items from Order
                                                        History</option>
                                                    <option value="Update Items in Order History">Update Items in Order
                                                        History</option>
                                                    <option value="Add Items to Vendor">Add Items to Vendor</option>
                                                    <option value="Edit Items from Vendor">Edit Items from Vendor
                                                    </option>
                                                    <option value="Update Items from Vendor">Update Items from Vendor
                                                    </option>
                                                </select>
                                                <span class="text-danger" [hidden]="!notificationType.errors.required"
                                                    *ngIf="notificationType.errors && (notificationType.touched || notificationType.dirty)">*Please
                                                    select Role
                                                </span>
                                            </div>
                                        </div>
                                        <!--/span-->
                                    </div>
                                    <!--/row-->
                                    <label class="control-label"> <span class="text-danger">*</span> Notification
                                        Title</label>
                                    <div class="row">
                                        <div class="col-md-12 ">
                                            <div class="form-group">
                                                <input type="text" id="notificationTitle" required
                                                    #notificationTitle="ngModel" name="notificationTitle"
                                                    [(ngModel)]="smsNotificationTextAddObj.notificationTitle"
                                                    class="form-control" rows="4">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!notificationTitle.errors.required"
                                                    *ngIf="notificationTitle.errors && (notificationTitle.touched || notificationTitle.dirty)">
                                                    This Field is Required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <label class="control-label"> <span class="text-danger">*</span> Notification
                                        Text</label>
                                    <div class="row">
                                        <div class="col-md-12 ">
                                            <div class="form-group">
                                                <textarea class="form-control" id="notificationTextDescripition"
                                                    required #notificationTextDescripition="ngModel"
                                                    name="notificationTextDescripition"
                                                    [(ngModel)]="smsNotificationTextAddObj.notificationTextDescription"
                                                    rows="4"></textarea>
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!notificationTextDescripition.errors.required"
                                                    *ngIf="notificationTextDescripition.errors && (notificationTextDescripition.touched || notificationTextDescripition.dirty)">
                                                    This Field is Required</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <br>
                                <div class="form-actions m-t-40">
                                    <button type="submit" style="background-color: #353556;color:white"
                                        [disabled]="!smsNotificationText.valid" class="btn "
                                        (click)="saveSmsNotificationTexts()">
                                        <i class="fa fa-check"></i> Submit</button>&nbsp;&nbsp;
                                    <button type="button" class="btn btn-dark" (click)="addAppNotificationText()"
                                        data-dismiss="modal">Cancel</button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>
            <!-- ============================================================== -->
            <!-- End PAge Content -->
            <!-- ============================================================== -->
            <!-- ============================================================== -->
            <!-- Right sidebar -->
            <!-- ============================================================== -->
            <!-- .right-sidebar -->
            <!-- ============================================================== -->
            <!-- End Right sidebar -->
            <!-- ============================================================== -->
        </div>
        <!-- ============================================================== -->
        <!-- End Container fluid  -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
    </div>
</div>
<div>
    <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Start Page Content -->
        <!-- ============================================================== -->
        <div class="row">
            <!-- Column -->
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="table-responsive">
                            <div id="zero_config_wrapper"
                                class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">



                                <div>
                                    <div>
                                        <mat-form-field>

                                            <input class="search" placeholder="Search" matInput
                                                (keyup)="applyFilter($event.target.value)">

                                        </mat-form-field>

                                    </div>
                                    <div class="table-responsive">
                                        <table class="table" id="Example table" mat-table
                                            [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                            <ng-container matColumnDef="notificationType">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Notification Type
                                                </th>
                                                <td *matCellDef="let row" style="padding-left: 14px;">
                                                    {{row.notificationType}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="notificationTitle">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Notification Title
                                                </th>
                                                <td *matCellDef="let row">
                                                    {{row.notificationTitle}}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="notificationTextDescription">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Notification Text
                                                    Description</th>
                                                <td *matCellDef="let row">
                                                    {{row.notificationTextDescription}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="status">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                                                <td *matCellDef="let row">
                                                    <span *ngIf="row.status==true"> Active</span>
                                                <span *ngIf="row.status==false"> In Active</span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="Action">
                                                <th mat-header-cell *matHeaderCellDef>Action</th>

                                                <td *matCellDef="let row">
                                                    <p *ngIf="read==true && write !=true && delete !=true"
                                                        style="color:#353556;font-family: initial;font-weight: 500;">You
                                                        don't have permissions to Edit/Delete</p>

                                                    <ul class="list-group list-group-flush"
                                                        *ngIf=" write==true || delete==true">
                                                        <li class="list-group-item  friend-list mb-2">
                                                          
                                                            <div class="dropdown show float-right list-block">
                                                                <a class="userDropdown" href="#" role="button"
                                                                    id="userDropdown" data-toggle="dropdown"
                                                                    aria-haspopup="true" aria-expanded="false"
                                                                    style="padding-right: 265px;"></a>
                                                                <div class="dropdown-menu dropdown-menu-right"
                                                                    aria-labelledby="userDropdown">
                                                                    <button class="dropdown-item" data-toggle="modal"
                                                                        data-target="#responsive" *ngIf=" write==true "
                                                                        (click)="getBySmsTextNotificationId(row._id)">
                                                                        <i class="fa fa-address-card"
                                                                            aria-hidden="true"></i>&nbsp;&nbsp;Edit</button>
                                                                    <button class="dropdown-item" *ngIf="delete==true"
                                                                        (click)="deleteSmsNotificationText(row._id)">
                                                                        <i class="fa fa-trash p-2"
                                                                            aria-hidden="true"></i>Delete</button>
                                                                    <div *ngIf="write==true">

                                                                        <mat-slide-toggle
                                                                            (change)="onChange($event,row._id)"
                                                                            [checked]="row.status">
                                                                            <span *ngIf="row.status==false">
                                                                                In Active</span>
                                                                            <span *ngIf="row.status==true">
                                                                                Active</span>
                                                                        </mat-slide-toggle>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                            </tr>
                                            <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                        </table>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25,100]"
                            showFirstLastButtons>
                        </mat-paginator>
                    </div>
                </div>
            </div>
            <!-- Column -->
        </div>
        <!-- ============================================================== -->
        <!-- End PAge Content -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Right sidebar -->
        <!-- ============================================================== -->
        <!-- .right-sidebar -->
        <!-- ============================================================== -->
        <!-- End Right sidebar -->
        <!-- ============================================================== -->
    </div>
</div>

<div id="responsive" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content bigModel" style="width:900px">
            <div class="modal-header">
                <h4>Edit Email Notification Text Management</h4>
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <form #smsNotificationTextUpdate="ngForm" novalidate>
                    <div class="form-body">

                        <div class="row">

                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label"> <span class="text-danger">*</span> Notification
                                        Type</label>
                                    <select class="form-control" id="notificationType" required
                                        #notificationType="ngModel" onfocus='this.size=5;' onblur='this.size=1;'
                                        onchange='this.size=1; this.blur();' name="notificationType"
                                        [(ngModel)]="smsNotificationTextAddObj.notificationType"
                                        data-placeholder="Choose a Notification Type" tabindex="1">
                                        <option value="User Sign Up Successful/Failure ">User Sign Up Successful/Failure
                                        </option>
                                        <option value="Account Sign UP ">Account Sign UP </option>
                                        <option value="Primary User Approval ">Primary User Approval </option>
                                        <option value="Add Items to Current Inventory ">Add Items to Current Inventory
                                        </option>
                                        <option value="Edit Items from Current Inventory  ">Edit Items from Current
                                            Inventory </option>
                                        <option value="Update Items in Current Inventory  ">Update Items in Current
                                            Inventory </option>
                                        <option value="Add Items to Shopping Cart  ">Add Items to Shopping Cart
                                        </option>
                                        <option value="Edit Items from Shopping Cart  ">Edit Items from Shopping Cart
                                        </option>
                                        <option value="Update Items in Shopping Cart  ">Update Items in Shopping Cart
                                        </option>
                                        <option value="Add Items to Open Order  ">Add Items to Open Order </option>
                                        <option value="Edit Items from Open Order  ">Edit Items from Open Order
                                        </option>
                                        <option value="Update Items from Open Order  ">Update Items from Open Order
                                        </option>
                                        <option value="Add Items to Order History">Add Items to Order History</option>
                                        <option value="Edit Items from Order History">Edit Items from Order History
                                        </option>
                                        <option value="Update Items in Order History">Update Items in Order History
                                        </option>
                                        <option value="Add Items to Vendor">Add Items to Vendor</option>
                                        <option value="Edit Items from Vendor">Edit Items from Vendor</option>
                                        <option value="Update Items from Vendor">Update Items from Vendor</option>
                                    </select>
                                    <span class="text-danger" [hidden]="!notificationType.errors.required"
                                        *ngIf="notificationType.errors && (notificationType.touched || notificationType.dirty)">*Please
                                        select Role
                                    </span>
                                </div>
                            </div>
                            <!--/span-->
                        </div>
                        <!--/row-->
                        <h5 class="card-title m-t-40"><span class="text-danger">*</span> Notification Title</h5>
                        <div class="row">
                            <div class="col-md-12 ">
                                <div class="form-group">
                                    <input type="text" id="notificationTitle" required #notificationTitle="ngModel"
                                        name="notificationTitle"
                                        [(ngModel)]="smsNotificationTextAddObj.notificationTitle" class="form-control"
                                        rows="4">
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!notificationTitle.errors.required"
                                        *ngIf="notificationTitle.errors && (notificationTitle.touched || notificationTitle.dirty)">
                                        This Field is Required</span>
                                </div>
                            </div>
                        </div>
                        <h5 class="card-title m-t-40"><span class="text-danger">*</span> Notification Text</h5>
                        <div class="row">
                            <div class="col-md-12 ">
                                <div class="form-group">
                                    <textarea class="form-control" id="notificationTextDescripition" required
                                        #notificationTextDescripition="ngModel" name="notificationTextDescripition"
                                        [(ngModel)]="smsNotificationTextAddObj.notificationTextDescription"
                                        rows="4"></textarea>
                                    <span style="font-size: small" class="text-danger"
                                        [hidden]="!notificationTextDescripition.errors.required"
                                        *ngIf="notificationTextDescripition.errors && (notificationTextDescripition.touched || notificationTextDescripition.dirty)">
                                        This Field is Required</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <br>
                    <div class="form-actions m-t-40">
                        <button type="submit" style="background-color: #353556;color:white" data-dismiss="modal"
                            [disabled]="!smsNotificationTextUpdate.valid" class="btn "
                            (click)="updateSmsNotificationText()">
                            <i class="fa fa-check"></i> Update</button>&nbsp;&nbsp;
                        <button type="button" class="btn btn-dark" data-dismiss="modal">Cancel</button>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>